/**
 * @generated SignedSource<<2541f0d5ee3cd8397f2f189334c132f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Error404Block_content$data = {
  readonly description: string;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "Error404Block_content";
};
export type Error404Block_content$key = {
  readonly " $data"?: Error404Block_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"Error404Block_content">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Error404Block_content",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": "title",
      "args": null,
      "kind": "ScalarField",
      "name": "Title",
      "storageKey": null
    },
    {
      "alias": "description",
      "args": null,
      "kind": "ScalarField",
      "name": "Description",
      "storageKey": null
    }
  ],
  "type": "ComponentContentError404",
  "abstractKey": null
};

(node as any).hash = "dfb04f9e252fcad1c16ed30576f716c7";

export default node;
